// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de/translation.json';
import en from './locales/en/translation.json';
import ar from './locales/ar/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    resources: {
      de: { translation: de },
      en: { translation: en },
      ar: { translation: ar }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
